import { Modal } from '@doordash/component-modal'
import { Icon, Inset } from '@doordash/design-language'
import * as React from 'react'
import { connect } from 'react-redux'
import { i18nKeys } from 'translationTypes'
import { AbnGuideItem } from '..'
import * as events from '../../../../../../events'
import i18n from '../../../../../../i18n'
import * as DA from '../../../../../../typeModules/events'
import { isMobile } from '../../../../../../utilities/userAgent'
import { Step } from '../Step'
import { ABN_LOOKUP_URL, config } from './config'

interface IAbnLookupProps {
  onClose: () => void
  trackBackgroundCheckSteps: (payload: unknown) => void
}

function AbnLookup({ onClose, trackBackgroundCheckSteps }: IAbnLookupProps) {
  const handlePrimaryButtonClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    trackBackgroundCheckSteps({
      page: DA.BackgroundCheckPages.ABN,
      action: DA.EventActions.Clicked,
      value: `${AbnGuideItem.LOOKUP}-external-link`,
    })

    e.preventDefault()
    window.open(ABN_LOOKUP_URL, '_blank')
  }
  return (
    <Modal
      onClose={onClose}
      size={Modal.Sizes.Medium}
      title={i18n.t(i18nKeys.backgroundCheck__abnLookup)}
      isFullScreenOnMobile
      shouldRenderStickyHeader={false}
      closeButtonSide={Modal.CloseButtonSides.Leading}
      primaryAction={{
        text: i18n.t(i18nKeys.backgroundCheck__abnLookup__ctaButton),
        onClick: handlePrimaryButtonClick,
        buttonProps: {
          trailingIcon: Icon.Types.LinkExternalLine,
          isInline: !isMobile,
        },
      }}
      useHairlineDividers
    >
      <Step {...config} />
      <Inset />
    </Modal>
  )
}

const mapDispatchToProps = {
  trackBackgroundCheckSteps: events.trackBackgroundCheckSteps,
}

export default connect(null, mapDispatchToProps)(AbnLookup)
